import { Component } from '@angular/core';
import { VersionType } from '../../../../../../enums/version-type';
import { CompareBaseModalComponent, CompareModalType } from '../../compare-base-modal.component';
import { CompareButtonComponent } from '../../components/compare-button/compare-button.component';
import { IconComponent } from '../../../../../ui/icon/icon.component';
import { TranslatePipe } from '../../../../../../pipes/translate/translate.pipe';
import { TextAreaComponent } from '@progress/kendo-angular-inputs';

@Component({
  selector: 'bizz-compare-modal',
  standalone: true,
  imports: [
    CompareButtonComponent,
    IconComponent,
    TranslatePipe,
    TextAreaComponent
  ],
  templateUrl: './compare-modal.component.html',
  styleUrl: './compare-modal.component.scss'
})
export class CompareModalComponent extends CompareBaseModalComponent {

  public onClick(event: MouseEvent, type: VersionType): void {
    if (this.modalType === CompareModalType.Delete)
      this.setSelectedVersion(type);
    const newTab = event && (event.ctrlKey || event.metaKey);
    const version = this.getVersionIdByType(type);

    if (typeof version !== 'number') {
      throw new Error('No valid version found');
    }

    this.modalData.onSelectVersionType(version, newTab);
  }

  public delete(): void {
    if (this.selectedVersion != undefined) {
      this.collectionListService.deleteInstance(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.selectedVersion, this.data.CollectionsID!, this.data.ID!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.data.VersionsID!, this.data.DraftsID!, this.deleteReason).subscribe({
        next: () => {
          //this.gridService.refreshLists();
        }
      });
    }
    this.dialogRef.close();
  }

  protected readonly CompareModalType = CompareModalType;
}
